


import { ContainedModal } from 'components/molecules';
import { PetTreatmentFiles } from 'components/molecules/pet/PetTreatmentFiles';
import { useTreatmentOnGoing } from 'context';

import React from 'react';

export const PetFilesModal: React.FC = () => {
  const { treatmentOnGoing, petFilesModal, imgs } = useTreatmentOnGoing();

  if (!treatmentOnGoing?.id) {
    return null;
  }

  return (
    <ContainedModal
      isOpen={petFilesModal.isOpen}
      onClose={petFilesModal.onClose}
      title="ARQUIVOS DO PET"
    >
      <PetTreatmentFiles
        paddingLeft={3}
        my={4} props={undefined}      />
    </ContainedModal>
  );
};

